import {EditIcon} from "@/theme/assets/icons";
import {Button} from "@/theme/ui";

export const EditButton = ({...rest}) => {
    return (
        <>
            <Button
                type="text"
                icon={<EditIcon />}
                {...rest}
            />
        </>
    );
}